import { useState, useCallback } from 'react';
import { FeatureLike } from 'ol/Feature';
import { toast } from 'react-toastify';
import { MapPresenter } from '../MapPresenter';


export function useMissedEvents(presenter: MapPresenter) {
    const [visible, setMissedEventsVisible] = useState<boolean>(false);
    const [modalVisible, setModalVisible] = useState<boolean>(false);
    const [feature, setFeature] = useState<FeatureLike | null>(null);
    const [interactionIsActive, setInteractionIsActive] = useState<boolean>(false);

    const toggle = useCallback(async () => {
        if (visible) {
            presenter.missedEvents.clear();
            setMissedEventsVisible(false);
            return;
        }

        const items = await presenter.missedEvents.show();
        const hasAny = (items?.length || 0) > 0;
        setMissedEventsVisible(hasAny);
        if (!hasAny) {
            toast.info("No missed events found");
        }
    }, [visible, presenter]);

    const startInteraction = useCallback(() => {
        setInteractionIsActive(true);
        presenter.missedEvents.addInteraction((feature) => {
            console.log("Click on the map to report a missed event.", feature);
            setFeature(feature);
            setModalVisible(true);
            setInteractionIsActive(false);
        });
    }, [presenter]);

    const finishInteraction = useCallback(() => {
        setInteractionIsActive(false);
        setModalVisible(false);
        presenter.missedEvents.clearInteraction();
    }, [presenter]);

    return {
        visible,
        modalVisible,
        feature,
        interactionIsActive,
        toggle,
        startInteraction,
        finishInteraction,
        setFeature,
        setModalVisible,
        setInteractionIsActive,
    };
}
